import { render, staticRenderFns } from "./MemberNews.vue?vue&type=template&id=13a6b621&scoped=true"
import script from "./MemberNews.vue?vue&type=script&lang=js"
export * from "./MemberNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6b621",
  null
  
)

export default component.exports